import React from "react";
import "./App.css";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Home from "./Sections/Home";
import About from "./Sections/About";
import Contact from "./Sections/Contact";

function App() {
  return (
    <div className="App">
      <Header />
      <div className="container">
        <Home />
        <About />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}

export default App;
